import { DifficultRoute } from 'entities/ticket/models/find-ticket/models.ts'

import { FavoriteParams } from 'shared/api/avia/favorites'
import { TicketClass } from 'shared/constants'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { showWrongDateFormat } from 'shared/lib/dateFormat'
import { TicketItem } from 'shared/models/ticket'

export const getSearchForm = (
  ticket: TicketItem | null,
  searchParamsFavorite: FavoriteParams | null,
) => {
  const segments = ticket?.segments || []
  const outboundSegments = segments.filter((s) => s.direction === 0)
  const returnSegments = segments.filter((s) => s.direction === 1)

  const firstOutbound = outboundSegments.at(0)
  const lastOutbound = outboundSegments.at(-1)

  const direction: DifficultRoute = {
    from: {
      cityName: firstOutbound?.dep?.city?.title || '',
      cityIataCode: firstOutbound?.dep?.airport?.code || '',
      countryName: firstOutbound?.dep?.country?.title || '',
    },
    to: {
      cityName: lastOutbound?.arr?.city?.title || '',
      cityIataCode: lastOutbound?.arr?.airport?.code || '',
      countryName: lastOutbound?.arr?.country?.title || '',
    },
    date: showWrongDateFormat(
      firstOutbound?.dep?.date,
      DATE_FORMAT_LIST.YEAR_FULL_DATE,
    ),
  }

  if (!!returnSegments.length) {
    const lastReturnSegment = returnSegments.at(-1)

    direction.back_date = showWrongDateFormat(
      lastReturnSegment?.arr?.date,
      DATE_FORMAT_LIST.YEAR_FULL_DATE,
    )
  }

  const directions = [direction]

  return {
    directions,
    adult: searchParamsFavorite?.adults || 0,
    child: searchParamsFavorite?.children || 0,
    infant: searchParamsFavorite?.infants || 0,
    infants_with_place: searchParamsFavorite?.infants_with_place || 0,
    cabin_class: prepareCabinClass(searchParamsFavorite?.cabin_class as string),
  }
}

export const prepareCabinClass = (cabin_class: string) => {
  return cabin_class === TicketClass.e.secondaryKey ||
    cabin_class === TicketClass.e.value
    ? TicketClass.e.key
    : TicketClass.b.key
}
